import React, { useEffect, useState } from "react";
import "./index.scss";
import PageHeader from "../../../adminCompenents/listComponents/Layout";
import CardContainer from "../../../adminCompenents/listComponents/UI/CardContainer";
import ExportButton from "../../../adminCompenents/listComponents/UI/ExportButton";
import AddButton from "../../../adminCompenents/listComponents/UI/AddButton";
import SearchFilterBar from "../../../adminCompenents/listComponents/UI/SearchFilterBar";
import DataTable from "../../../adminCompenents/listComponents/UI/DataTable";
import DataCards from "../../../adminCompenents/listComponents/UI/DataCards";
import Pagination from "../../../adminCompenents/listComponents/UI/Pagination";
import DrawerForm from "../../../adminCompenents/listComponents/UI/DrawerForm";
import { showErrorToaster } from "../../../adminCompenents/listComponents/UI/toaster/error";
import { showSuccessToaster } from "../../../adminCompenents/listComponents/UI/toaster/success";
import { exportCSV } from "../../../adminCompenents/utils";

const ContactsPage = () => {
  const [contacts, setContacts] = useState([]);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const perPage = 5;
  const [filters, setFilters] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [editContact, setEditContact] = useState(null);
  const [showDrawer, setShowDrawer] = useState(false);

  // 👉 Responsive
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 👉 Charger contacts
  const loadData = async () => {
    setIsLoading(true);
    try {
      const res = await fetch("https://api.almasecret.msit-demo.fr/contacts");
      const data = await res.json();
      setContacts(Array.isArray(data) ? data : data.data || []);
    } catch (error) {
      showErrorToaster("Erreur lors du chargement des contacts");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  // 👉 Filtrage
  const filtered = contacts.filter((c) => {
    return (
      c.fullname?.toLowerCase().includes(search.toLowerCase()) &&
      (filters?.email
        ? c.email?.toLowerCase().includes(filters.email.toLowerCase())
        : true)
    );
  });

  const totalPages = Math.ceil(filtered.length / perPage);
  const paginated = filtered.slice((page - 1) * perPage, page * perPage);

  // 👉 Supprimer un contact
  const handleDelete = async (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce contact ?")) {
      try {
        const res = await fetch(`https://api.almasecret.msit-demo.fr/contacts/${id}`, {
          method: "DELETE",
        });
        if (res.ok) {
          setContacts((prev) => prev.filter((c) => c._id !== id));
          showSuccessToaster("Contact supprimé avec succès");
        } else {
          showErrorToaster("Erreur lors de la suppression");
        }
      } catch (err) {
        showErrorToaster("Erreur de connexion");
      }
    }
  };

  // 👉 Colonnes
  const columns = [
    { header: "Nom", accessor: "fullname" },
    { header: "Téléphone", accessor: "phone" },
    { header: "Email", accessor: "email" },
    { header: "Sujet", accessor: "subject" },
    { header: "Message", accessor: "message" },
    {
      header: "Date",
      accessor: "createdAt",
      Cell: (value) =>
        value ? new Date(value).toLocaleDateString("fr-FR") : "-",
    },
  ];

  // 👉 Actions
  const rowActions = (row) => [
    {
      label: "Supprimer",
      onClick: () => handleDelete(row._id),
    },
  ];

  // 👉 Drawer (ajout manuel)
  const fields = [
    { name: "fullname", label: "Nom complet", required: true },
    { name: "phone", label: "Téléphone", required: true },
    { name: "email", label: "Email", type: "email", required: true },
    { name: "subject", label: "Sujet" },
    { name: "message", label: "Message", type: "textarea" },
  ];

  const handleSubmit = async (formData, editContact = null) => {
    try {
      if (editContact) {
        // édition (rare pour contact)
      } else {
        const res = await fetch("https://api.almasecret.msit-demo.fr/contacts", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });
        if (res.ok) {
          const newContact = await res.json();
          setContacts((prev) => [...prev, newContact]);
          showSuccessToaster("Contact ajouté avec succès");
        } else {
          showErrorToaster("Erreur lors de l'ajout du contact");
        }
      }
      setShowDrawer(false);
      setEditContact(null);
    } catch (err) {
      showErrorToaster("Erreur de connexion");
    }
  };

  // 👉 Filtres
  const filterFields = [
    { name: "email", label: "Email", placeholder: "Search email..." },
  ];

  return (
    <div>
      <PageHeader
        title="Contacts"
        breadcrumb={[{ label: "Accueil", href: "/" }, { label: "Contacts" }]}
      />

      <CardContainer>
        <div className="d-flex justify-content-between align-items-center mb-3 m-4">
          <h5 className="title-liste">Liste des contacts</h5>
          <div className="d-flex gap-2">
            <ExportButton
              onClick={() => {
                exportCSV(
                  [
                    "fullname",
                    "email",
                    "phone",
                    "subject",
                    "message",
                    "createdAt",
                  ],
                  paginated,
                  "contacts.csv"
                );
              }}
            />
            <AddButton label="Contact" onClick={() => setShowDrawer(true)} />
          </div>
        </div>

        <hr className="hr-table" />
        <SearchFilterBar
          fields={filterFields}
          onSearch={setSearch}
          onFilter={(f) => setFilters(f)}
        />
        <hr className="hr-table" />

        {/* ✅ Responsive */}
        {isMobile ? (
          <DataCards
            columns={columns}
            data={paginated}
            keyField="_id"
            rowActions={rowActions}
          />
        ) : (
          <DataTable
            columns={columns}
            data={paginated}
            keyField="_id"
            rowActions={rowActions}
          />
        )}

        <Pagination
          currentPage={page}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      </CardContainer>

      {/* Drawer Form */}
      <DrawerForm
        show={showDrawer}
        onClose={() => {
          setShowDrawer(false);
          setEditContact(null);
        }}
        title={editContact ? "Modifier un contact" : "Ajouter un contact"}
        fields={fields}
        initialData={editContact}
        onSubmit={(data) => handleSubmit(data, editContact)}
      />
    </div>
  );
};

export default ContactsPage;
